import I18n from 'I18n';
// @ts-expect-error Not yet typed
import { growl } from 'EmailComponents/errors/growl';
import { registerQuery, registerMutation } from 'data-fetching-client';
import { generateYearInReviewExport, fetchRollupLimitRequest } from '../apis/export';
export const GENERATE_YEAR_IN_REVIEW_REQUEST = registerMutation({
  fieldName: 'generateYearInReview',
  args: [],
  fetcher() {
    return generateYearInReviewExport().then(() => {
      growl('success', I18n.text(`email-management.yearInReview.alert.creationMessage`));
      return;
    }).catch(() => {
      growl('error', I18n.text(`email-management.yearInReview.alert.errorMessage`));
    });
  }
});
export const FETCH_PORTAL_ROLL_UP_LIMIT = registerQuery({
  fieldName: 'portalRollUpLimit',
  fetcher() {
    return fetchRollupLimitRequest();
  }
});